module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-mt4 u-mb4"
  }, [_c('h2', {
    staticClass: "secondary-header"
  }, [_vm._v(_vm._s(_vm.t('account.account_settings')))])]), _vm._v(" "), _c('bc-edit-authentication')], 1)
},staticRenderFns: []}